export interface EmailTemplateParam {
  name: string;
  label: string;
}

const BASE_PARAMS: EmailTemplateParam[] = [
  { name: 'Timestamp', label: 'Timestamp' },
  { name: 'Date', label: 'Date' },
  { name: 'IecdbPhone', label: 'IECDB Phone' },
  { name: 'IecdbEmail', label: 'IECDB Email' },
];

// Keyed by EmailTemplateType ID
const EMAIL_TEMPLATE_PARAMS: Record<number, EmailTemplateParam[]> = {
  1: [...BASE_PARAMS],
  2: [
    ...BASE_PARAMS,
    { name: 'CommitteeNm', label: 'Committee Name' },
    { name: 'FilingPeriodDesc', label: 'Filing Period' },
  ],
  3: [
    ...BASE_PARAMS,
    { name: 'Username', label: 'Username' },
    { name: 'PeriodDesc', label: 'Period Description' },
  ],
  4: [...BASE_PARAMS, { name: 'CommitteeName', label: 'Committee Name' }],
  5: [...BASE_PARAMS, { name: 'CommitteeName', label: 'Committee Name' }],
  6: [...BASE_PARAMS],
  7: [
    ...BASE_PARAMS,
    { name: 'CommitteeName', label: 'Committee Name' },
    { name: 'DueDate', label: 'Due Date' },
    { name: 'EndDate', label: 'End Date' },
    { name: 'PeriodDesc', label: 'Period Description' },
  ],
  8: [
    ...BASE_PARAMS,
    { name: 'CommitteeName', label: 'Committee Name' },
    { name: 'DueDate', label: 'Due Date' },
    { name: 'DueTime', label: 'Due Time' },
    { name: 'FiledDate', label: 'Filed Date' },
    { name: 'Amount', label: 'Amount' },
  ],
  9: [...BASE_PARAMS, { name: 'OfficialName', label: 'Official Name' }],
  10: [
    ...BASE_PARAMS,
    { name: 'CommitteeName', label: 'Committee Name' },
    { name: 'DueDate', label: 'Due Date' },
    { name: 'EndDate', label: 'End Date' },
    { name: 'PeriodDesc', label: 'Period Description' },
  ],
  11: [
    ...BASE_PARAMS,
    { name: 'CommitteeName', label: 'Committee Name' },
    { name: 'DueDate', label: 'Due Date' },
    { name: 'EndDate', label: 'End Date' },
    { name: 'PeriodDesc', label: 'Period Description' },
  ],
};

export default EMAIL_TEMPLATE_PARAMS;
